<template>
  <div class="container">
    <div class="wrapper">
      <!-- <img src="@/assets/img/iso.png"/> -->
      <badge :image="'iso.png'">ISO 9001 is een wereldwijd erkende norm met eisen op het gebied van kwaliteitsmanagement en daardoor een maatstaf voor transparantie en betrouwbaarheid in de markt</badge>
      <badge :image="'munster.png'"></badge>
      <badge :image="'vca.png'">VCA staat voor Veiligheids Checklijst Aannemers. Dit is een jaarlijkse controle waarbij ons bedrijf wordt gecontroleerd veiligheid, gezondheid en milieu.</badge>
    </div>
  </div>
</template>
<script>
import Badge from '@/components/Badge.vue'

export default {
  name: 'Badges',
  components: { Badge },
}
</script>
<style lang="scss" scoped>
  .container {
    background: darkgray;
    padding-bottom: 30px;
    padding-top: 30px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100%;
  }
  .wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  @media screen and (max-width: 1024px) {
    .container {
      padding-left: 0;
      padding-right: 0;
    }
  }
</style>
